import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Nav, OverlayTrigger, Row, Popover, Image } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getContent } from '../../redux/actions/healthSystem'
import { logoutUser } from '../../redux/actions/user'
import PropTypes from 'prop-types'
import { formatMiddleName, transformDate } from '../../utils/helpers'
import { Link, useHistory } from 'react-router-dom'
import format from 'date-fns/format'
import PatientSynopsisModal from '../Modals/PatientSynopsisModal'
import { showSynopsis } from '../../redux/actions/synopsis'
import RawDataModal from '../Modals/RawDataModal'
import useDimensions from '../../hooks/useDimensions'
import CalendarCheck from '../../assets/icons/calendar-check.svg'
import ClipboardDataFill from '../../assets/icons/clipboard-data-fill.svg'

const renderPopover = (content, showAbout) => {
  const headerContent = content.find((c) => c.contentTypeId === 1)
  return (
    <Popover id='popover-basic'>
      <Popover.Content 
        className='text-center'
        onMouseEnter={() => showAbout(true)}
        onMouseLeave={() => showAbout(false)}
      >
        {headerContent ? 
          (<div dangerouslySetInnerHTML={{ __html: headerContent.description }}></div>) 
          : ''}
      </Popover.Content>
    </Popover>
  )
}

const AppHeader = ({ showNav, showNavResult, type, showUser }) => {
  const dispatch = useDispatch()

  const [show, setShow] = useState(false)
  const [showAbout, setShowAbout] = useState(false)

  const activeKey = useSelector((state) => state.header.activeKey)
  const encounter = useSelector((state) => state.patient.encounter)
  const user = useSelector((state) => state.user.user)
  const content = useSelector((state) => state.healthSystem.content)
  const logoutState = useSelector((state) => state.user.logout)
  const patient = useSelector((state) => state.patient.patient)

  const { width } = useDimensions()

  useEffect(() => {
    if (type === 'epic') {
      dispatch(getContent())
    }
  }, [type])

  const history = useHistory()
  useEffect(() => {
    if (logoutState.success) {
      history.push('/login')
    }
  }, [logoutState.success])

  const handleLogout = (event) => {
    event.preventDefault()
    dispatch(logoutUser(user.userId))
  }

  if (type === 'epic') {
    return (
      <header>
        <Container fluid className='mt-2'>
          <Row>
            <Col xs='auto'>
              <h5 className='mt-2 font-weight-bold'>Lupus Advisor</h5>
            </Col>
            {
              showNav && (
                <Col xs='auto'>
                  <Nav
                    variant='tabs'
                    className='border-0'
                    activeKey={activeKey}
                  >
                    <Nav.Item>
                      <Nav.Link eventKey='assessment' disabled={activeKey !== 'assessment'} className={`${activeKey === 'assessment' ? 'active' : ''}`} tabIndex='-1' aria-disabled='true'>1. Assessment</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey='ccp' disabled={activeKey !== 'ccp'} tabIndex='-1' aria-disabled='true' className={`${activeKey === 'ccp' ? 'active' : ''}`}>2. Collaborative Care Plan</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey='wrapup' disabled={activeKey !== 'wrapup'} tabIndex='-1' aria-disabled='true' className={`${activeKey === 'wrapup' ? 'active' : ''}`}>3. Wrap Up</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
              )
            }
            {
              showNavResult && (
                <Col xs='auto' className='mt-2 text-center' id='header-result'>
                  <h5>Results of Lupus Advisor Session completed on {format(new Date(encounter.status.updatedAt), 'MM/dd/yyyy')}</h5>
                </Col>
              )
            }
            {
              width > 986 && (
                <>
                  <Col id='about' xs='auto' className='mt-1 text-right'>
                    <OverlayTrigger
                      show={showAbout}
                      placement='left'
                      overlay={renderPopover(content, setShowAbout)}
                    >
                      <span 
                        className='d-inline-block mr-3'
                        onMouseEnter={() => setShowAbout(true)}
                        onMouseLeave={() => setShowAbout(false)}
                      >
                        <Button
                          id='about-btn'
                          variant='light'
                          style={{ pointerEvents: 'none' }}
                        >
                    About {width > 1115 && 'Lupus Advisor'}
                        </Button>
                      </span>
                    </OverlayTrigger>
                  </Col>
                  {
                    showNav && (
                      <Col id='synopsis' xs='auto'>
                        {
                          width >= 1036 ? (
                            <>
                              <h5 onClick={() => dispatch(showSynopsis(true))}>Patient Synopsis</h5>
                              <div className='font-weight-bold'>
                                {patient && `${patient.firstName} ${formatMiddleName(patient.middleName)} ${patient.lastName}`} - <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setShow(true)}>{encounter && format(new Date(transformDate(encounter.date)), 'MM/dd/yyyy')}</span>
                              </div>
                            </>
                          ) : (
                            <div className='text-center' id='small-header'>
                              <div className='font-weight-bold'>
                                {patient && `${patient.firstName} ${formatMiddleName(patient.middleName)} ${patient.lastName}`}
                              </div>
                              <Image src={CalendarCheck} alt='Raw Data' className='mr-2 filter-header-icon' onClick={() => setShow(true)} />
                              <Image src={ClipboardDataFill} alt='Patient Synopsis' className='filter-header-icon' onClick={() => dispatch(showSynopsis(true))} />
                            </div>
                          )
                        }
                      </Col>
                    )
                  }
                </>
              )
            }
          </Row>
          {
            width < 986 && (
              <Row>
                <Col xs={9} id='about-mobile'>
                  <OverlayTrigger
                    show={showAbout}
                    placement='left'
                    overlay={renderPopover(content, setShowAbout)}
                  >
                    <span 
                      className='d-inline-block mr-3'
                      onMouseEnter={() => setShowAbout(true)}
                      onMouseLeave={() => setShowAbout(false)}
                    >
                      <Button
                        id='about-btn'
                        variant='light'
                        style={{ pointerEvents: 'none' }}
                      >
                      About Lupus Advisor
                      </Button>
                    </span>
                  </OverlayTrigger>
                </Col>
                <Col xs={3} id='synopsis'>
                  <div id='small-header' className='d-flex justify-content-between my-2'>
                    <div className='font-weight-bold'>
                      {patient && `${patient.firstName} ${formatMiddleName(patient.middleName)} ${patient.lastName}`}
                    </div>
                    <div>
                      <Image src={CalendarCheck} alt='Raw Data' className='mr-2 filter-header-icon' onClick={() => setShow(true)} />
                      <Image src={ClipboardDataFill} alt='Patient Synopsis' className='filter-header-icon' onClick={() => dispatch(showSynopsis(true))} />
                    </div>
                  </div>
                </Col>
              </Row>
            )
          }
        </Container>
        <PatientSynopsisModal />
        <RawDataModal 
          show={show}
          onClose={() => setShow(false)}
        />
      </header>
    )
  }

  return (
    <header>
      <Container fluid className='mt-3'>
        <Row>
          <Col lg={7} md={6}>
            {
              user.role !== undefined ? (
                <Link to={user.role.roleId === 1 ? '/configurator' : `/health-system/${user.healthSystem.tenant}`}>
                  <h4>
                    <span className='slate-gray'>Lupus Advisor</span> {' '}
                    <span className='black'>Configurator</span>
                  </h4>
                </Link>
              ) : (
                <h4>
                  <span className='slate-gray'>Lupus Advisor</span> {' '}
                  <span className='black'>Configurator</span>
                </h4>
              )
            }
          </Col>
          {
            showUser && (
              <Col lg={5} md={6}>
                <div className='header-user-text text-right'>
                  Hi {user.email} | <Link to='/change-password'>Reset Password</Link> | <a href='#' onClick={(event) => handleLogout(event)}>Log out</a>
                </div>
              </Col>
            )
          }
        </Row>
      </Container>
    </header>
  )
}

AppHeader.propTypes = {
  showNav: PropTypes.bool,
  showNavResult: PropTypes.bool,
  type: PropTypes.string,
  showUser: PropTypes.bool
}

export default AppHeader
